import { expVal } from '@atlassian/jira-feature-experiments';

const BoardHarmonisationMilestone3 = {
	get(): boolean {
		return expVal('board_harmonisation_m3_swimlanes', 'isEnabled', false);
	},
};

// eslint-disable-next-line import/no-default-export
export default BoardHarmonisationMilestone3;
